<template>
  <v-row>
    <v-col cols="12" class="header">
      <v-icon>fas fa-address-card</v-icon>
      <h2>Dados do Colaborador</h2>
    </v-col>
    <v-col cols="12" class="dados-colaborador-itens">
      <p>
        <b>Nome:</b> {{ dadosColaborador.nomeAvaliado }}
        <i v-if="dadosColaborador.nomeAvaliado == null">Sem informação</i>
      </p>
      <p><b>Matrícula:</b> {{ dadosColaborador.matricula }}</p>
      <p><b>Data Admissão:</b> {{ formatarData(dadosColaborador.dataAdmissao) }}</p>
      <p>
        <b>Tempo de casa:</b>
        {{ calcularTempoDeCasa(dadosColaborador.dataAdmissao).toFixed(2) }} Anos
      </p>
      <p><b>Lotação:</b> {{ dadosColaborador.lotacao }}</p>
      <p>
        <b>Cargo:</b> {{ dadosColaborador.cargo }}
        <i v-if="dadosColaborador.cargo == null">Sem informação</i>
      </p>
      <p>
        <b>Descrição Cargo:</b> {{ dadosColaborador.descricao }}
        <i v-if="dadosColaborador.descricao == null">Sem informação</i>
      </p>

      <v-divider class="my-5" />
    </v-col>
  </v-row>
</template>

<script>
import JS from './methods.js';

export default {
  name: 'DadosColaborador',
  props: { dadosColaborador: { type: Object, default: () => ({}) } },
  methods: {
    ...JS,
  },
};
</script>
